var _style, _g, _g2, _defs, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#8F00FF;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 12.7,
    y: 16.4,
    width: 29.6,
    height: 24.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.7,17.2h-2.9c-0.2-0.5-0.7-0.8-1.3-0.8s-1.1,0.3-1.3,0.8h-2.9c-0.9,0-0.9,1.2,0,1.2h2.9 c0.1,0.3,0.4,0.5,0.7,0.7v1.7c-0.8,0.2-1.5,0.8-1.9,1.6H20.1c-0.4-0.7-1-1.4-1.9-1.6v-1.7c0.3-0.1,0.5-0.4,0.7-0.7h2.9 c0.9,0,0.9-1.2,0-1.2H19c-0.3-0.5-0.8-0.8-1.4-0.8c-0.6,0-1.1,0.3-1.3,0.8h-2.9c-0.9,0-0.9,1.2,0,1.2h2.9c0.1,0.3,0.4,0.5,0.7,0.7 v1.7c-1.5,0.4-2.2,2-2.2,3.4c0,1.5,1,3.5,3,3.5c1,0,1.9-0.7,2.4-1.5c2,0.7,2.7,1.6,3.4,2.4c2.7,3.3,5.6,3.2,8.2,0 c0.7-0.8,1.4-1.7,3.4-2.4c0.5,0.9,1.3,1.5,2.4,1.5c1.9,0,3-2,3-3.5c0-1.4-0.7-3-2.2-3.4v-1.7c0.3-0.1,0.5-0.4,0.7-0.7h2.9 C42.5,18.4,42.5,17.2,41.7,17.2z M27.5,27.6c-0.9,0-1.6-0.7-1.6-1.4c0-0.8,0.7-1.4,1.6-1.4s1.6,0.7,1.6,1.4 C29.1,27,28.4,27.6,27.5,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.2,36.8c0.5-0.8,1.7,0,1.2,0.8c-2.7,3.9-9,4-11.7,0c-0.5-0.8,0.7-1.5,1.2-0.8C25,39.9,30.1,39.9,32.2,36.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.5,32.8c0.5-0.8,1.7-0.1,1.2,0.7c-1,1.6-3.5,1.5-4.4,0c-0.5-0.8,0.7-1.5,1.2-0.7 C27,33.4,28.1,33.4,28.5,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.5,34.8c0.6-0.7,1.7,0.1,1.1,0.9c-2,2.5-6.2,2.5-8.2,0c-0.6-0.7,0.6-1.6,1.1-0.9 C26,36.6,29.1,36.6,30.5,34.8z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uas.aa60b8079de66b87f01e93a971c3a5fd.svg";